<tc-setup-grid
    #setupGrid
    [readOnly]="true"
    [colDefConfig]="colDefConfig"
    [setupGridComp]="this"
    [dataSource]="this"
    [noSelection]="true"
    [rowClassRules]="rowClassRules">
</tc-setup-grid>
